var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJointhecommunityYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6146_6689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4085 0.906664C39.2167 1.36764 40.6378 2.72096 41.1218 4.44305C41.9965 7.56125 42 14.071 42 14.071C42 14.071 42 20.5807 41.1218 23.6989C40.6378 25.421 39.2167 26.7743 37.4085 27.2352C34.1345 28.0716 20.9999 28.0716 20.9999 28.0716C20.9999 28.0716 7.86548 28.0716 4.59136 27.2352C2.78318 26.7743 1.3622 25.421 0.878169 23.6989C0 20.5807 0 14.071 0 14.071C0 14.071 0 7.56125 0.878169 4.44305C1.3622 2.72096 2.78318 1.36764 4.59136 0.906664C7.86548 0.0703125 20.9999 0.0703125 20.9999 0.0703125C20.9999 0.0703125 34.1345 0.0703125 37.4085 0.906664ZM27.7064 14.0697L16.7949 20.069V8.07031L27.7064 14.0697Z",
    fill: "#848484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6146_6689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointhecommunityYoutube);
export default __webpack_public_path__ + "static/media/jointhecommunity-youtube.8a8f6135b5bc92a0d73dadb823a274fc.svg";
export { ForwardRef as ReactComponent };